class FreeSwatches extends HTMLElement {
  constructor() {
    super()
    this.swatches = []
    this.chosenSwatches = []
    this.otherFabricQuantity = 0
    this.drawerEl = null
    this.bodyEl = null
    this.selectedEl = null
    this.submitBtn = null
  }

  connectedCallback() {
    this.drawerEl = this.querySelector('.free-swatches-drawer')
    this.bodyEl = this.querySelector('.drawer-body')
    this.selectedEl = this.querySelector('.selected-swatches')
    this.submitBtn = this.querySelector('#submit-button')

    this.loadSwatches()
    this.attachGlobalToggle()
    this.attachCloseHandlers()
    this.fetchCart()
  }

  loadSwatches() {
    try {
      const jsonEl = document.querySelector('script[data-free-swatch-variants="json"]')
      if (jsonEl) {
        this.swatches = JSON.parse(jsonEl.textContent || '[]') || []
      }
    } catch (e) {}
    this.renderGrid()
    this.renderSelected()
    this.updateSubmitVisibility()
  }

  attachGlobalToggle() {
    const toggle = document.getElementById('free-swatches')
    if (toggle) {
      toggle.addEventListener('click', () => this.toggleDrawer())
    }
  }

  attachCloseHandlers() {
    this.addEventListener('click', (e) => {
      const t = e.target
      if (t && (t.getAttribute('data-action') === 'close')) {
        this.closeDrawer()
      }
    })
  }

  fetchCart() {
    fetch((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/' + 'cart.js')
      .then((r) => r.json())
      .then((data) => {
        const items = data.items || []
        let other = 0
        const chosen = []
        for (const item of items) {
          if (!String(item.title || '').toLowerCase().includes('fabric')) {
            continue
          }
          const match = this.swatches.find((s) => s && s.id === item.variant_id)
          if (match) {
            chosen.push({
              id: item.variant_id,
              public_title: item.variant_title,
              featured_image: { src: item.image },
            })
          } else {
            other += item.quantity || 0
          }
        }
        this.chosenSwatches = chosen
        this.otherFabricQuantity = other
        this.renderGrid()
        this.renderSelected()
        this.updateSubmitVisibility()
      })
      .catch(() => {})
  }

  toggleDrawer() {
    if (!this.drawerEl) return
    this.drawerEl.classList.toggle('active')
  }

  closeDrawer() {
    if (!this.drawerEl) return
    this.drawerEl.classList.remove('active')
  }

  onChoose(id) {
    const exists = this.chosenSwatches.find((s) => s.id === id)
    if (exists) {
      this.chosenSwatches = this.chosenSwatches.filter((s) => s.id !== id)
    } else if (this.chosenSwatches.length + (this.otherFabricQuantity || 0) < 100) {
      const sw = this.swatches.find((s) => s.id === id)
      if (sw) this.chosenSwatches.push(sw)
    }
    this.renderGrid()
    this.renderSelected()
    this.updateSubmitVisibility()
  }

  updateSubmitVisibility() {
    if (!this.submitBtn) return
    if ((this.chosenSwatches || []).length > 0) {
      this.submitBtn.style.display = ''
      this.submitBtn.onclick = () => this.addSwatchToCart()
    } else {
      this.submitBtn.style.display = 'none'
      this.submitBtn.onclick = null
    }
  }

  renderGrid() {
    if (!this.bodyEl) return
    const html = (this.swatches || [])
      .map((sw) => {
        const chosen = !!this.chosenSwatches.find((s) => s.id === sw.id)
        const klass = chosen ? 'chosen-swatch' : 'not-chosen-swatch'
        const iconChosen = '<svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 26 26"><g fill="#fff" stroke="#d5d5d5" stroke-width="1"><circle cx="13" cy="13" r="13" stroke="none"></circle><circle cx="13" cy="13" r="12.5" fill="none"></circle></g><g transform="translate(7 7)"><line x2="12" transform="translate(0 6)" fill="none" stroke="#202020" stroke-width="1"></line></g></svg>'
        const iconPlus = '<svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 26 26"><g fill="#fff" stroke="#d5d5d5" stroke-width="1"><circle cx="13" cy="13" r="13" stroke="none"></circle><circle cx="13" cy="13" r="12.5" fill="none"></circle></g><g transform="translate(7 7)"><line x2="12" transform="translate(0 6)" fill="none" stroke="#202020" stroke-width="1"></line><line x2="12" transform="translate(6) rotate(90)" fill="none" stroke="#202020" stroke-width="1"></line></g></svg>'
        return (
          '<div class="swatch-element">' +
          '<div class="' + klass + '" data-variant-id="' + String(sw.id) + '">' +
          '<div class="swatch-image">' +
          '<img src="' + (sw && sw.featured_image && sw.featured_image.src ? sw.featured_image.src : '') + '" width="auto" height="auto" alt="' + (sw.public_title || '') + '">' +
          '</div>' +
          '<div class="swatch-label">' +
          '<div class="swatch-label-text">' + (sw.public_title || '') + '</div>' +
          '<div class="swatch-label-icon">' + (chosen ? iconChosen : iconPlus) + '</div>' +
          '</div>' +
          '</div>' +
          '</div>'
        )
      })
      .join('')
    this.bodyEl.innerHTML = html
    this.bodyEl.querySelectorAll('[data-variant-id]').forEach((el) => {
      el.addEventListener('click', () => {
        const id = Number(el.getAttribute('data-variant-id'))
        this.onChoose(id)
      })
    })
  }

  renderSelected() {
    if (!this.selectedEl) return
    const html = (this.chosenSwatches || [])
      .map((sw) => {
        return (
          '<div class="selected-swatch">' +
          '<div class="selected-swatch-image">' +
          '<img src="' + (sw && sw.featured_image && sw.featured_image.src ? sw.featured_image.src : '') + '" width="auto" height="auto" alt="' + (sw.public_title || '') + '">' +
          '</div>' +
          '<div class="selected-swatch-label">' +
          '<div class="selected-swatch-label-text">' + (sw.public_title || '') + '</div>' +
          '</div>' +
          '</div>'
        )
      })
      .join('')
    this.selectedEl.innerHTML = html
  }

  addSwatchToCart() {
    if (!this.submitBtn) return
    this.submitBtn.classList.add('disabled')
    const updates = {}
    ;(this.swatches || []).forEach((s) => {
      updates[s.id] = 0
    })
    ;(this.chosenSwatches || []).forEach((s) => {
      updates[s.id] = 1
    })

    fetch(((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/') + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ updates }),
    })
      .then((r) => r.json())
      .then((r) => {
        this.closeDrawer()
        const bubble = document.querySelector('#CartBubble')
        if (bubble) bubble.innerHTML = r && r.item_count != null ? r.item_count : ''
      })
      .catch(() => {})
      .finally(() => {
        this.submitBtn.classList.remove('disabled')
        const modal = document.querySelector('cart-modal')
        if (modal && typeof modal.reloadContent === 'function') modal.reloadContent()
      })
  }
}

customElements.define('free-swatches', FreeSwatches)
